export default __webpack_public_path__ + "static/media/NotoSansKR-Medium.e5d0c16f.woff2";